module.exports = __webpack_public_path__ + "static/media/icon-x-dark.c6bdf02e.svg";